<template>
  <div />
</template>

<script>
import { mapActions } from 'vuex'

/**
 * Vue: Collectors club settings (collectors-club-settings)
 * -----------------------------------------------------------------------------
 * A component to manage state for collectors club.
 * - Component settings: section / dynamic / global
 *
 * @param {Boolean|Object} article - Canvas Article Object.
 * @param {Boolean|Object} blog - Canvas Blog Object.
 * @param {Boolean|Object} collection - Canvas Collection Object.
 * @param {Boolean|Object} page - Canvas Page Object.
 * @param {Boolean|Object} product - Canvas Product Object.
 * @param {Boolean|Object} variant - Canvas Variant Object.
 * @param {Boolean|Object} membershipProduct - Product Object for Membership
 * product.
 * @param {Object} freeMembership - Settings for free membership.
 */
export default {
  name: 'CollectorsClubSettings',

  props: {
    article: {
      type: [Boolean, Object],
      default: false,
    },
    blog: {
      type: [Boolean, Object],
      default: false,
    },
    collection: {
      type: [Boolean, Object],
      default: false,
    },
    page: {
      type: [Boolean, Object],
      default: false,
    },
    product: {
      type: [Boolean, Object],
      default: false,
    },
    variant: {
      type: [Boolean, Object],
      default: false,
    },
    membershipProduct: {
      type: [Boolean, Object],
      default: false,
    },
    freeMembership: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      cnvsGlobal: true,
    }
  },

  computed: {
    content() {
      return {
        article: this.article,
        blog: this.blog,
        collection: this.collection,
        page: this.page,
        product: this.product,
        variant: this.variant,
      }
    },
  },

  watch: {
    content: {
      deep: true,
      immediate: true,
      handler() {
        this.setContent(this.content)
      },
    },
  },

  mounted() {
    this.setMembershipProduct(this.membershipProduct)
    this.setFreeMembershipContent(this.freeMembership)
  },

  methods: {
    ...mapActions({
      setContent: 'collectorsClub/setContent',
      setMembershipProduct: 'collectorsClub/setMembershipProduct',
      setFreeMembershipContent: 'collectorsClub/setFreeMembershipContent',
    }),
  },
}
</script>
